import { createAction, props } from '@ngrx/store';
import { Contact } from '../../models/contact';
import { ContactsQuery } from '../../models/contacts-query';

export const contactsTableRequest = createAction(
    '[Contacts Table] Load Request'
);

export const contactsTableSuccess = createAction(
    '[Contacts Table] Load Response',
    props<{ totalCount: number, page: Contact[] }>()
);

export const contactsTableFailure = createAction(
    '[Contacts Table] Load Failure'
);

export const contactsTableChangePage = createAction(
    '[Contacts Table] Change Page',
    props<{ pageNumber: number, itemsPerPage: number }>()
);

export const contactsTableChangeQuery = createAction(
    '[Contacts Table] Change Filter',
    props<{ query: ContactsQuery }>()
);

export const contactsTableSort = createAction(
    '[Contacts Table] Change Sort Column',
    props<{ id: string, descending: boolean }>()
);

export const contactsTableSetSelection = createAction(
    '[Contacts Table] Set Selection',
    props<{ selection: string[] }>()
);

export const contactsTableMasterToggle = createAction(
    '[Contacts Table] Master Selection Toggle'
);

export const contactsTableToggle = createAction(
    '[Contacts Table] Toggle Selection',
    props<{ id: string }>()
);

export const contactsTableAddAssist = createAction(
    '[Contacts Table] Add Filter Assist',
    props<{ id: string, parameter: any }>()
);

export const contactsTableRemoveAssist = createAction(
    '[Contacts Table] Remove Filter Assist',
    props<{ id: string }>()
);

export const contactSaveRequest = createAction(
    '[Contact] Save Contact Request',
    props<{ contact: Contact }>()
);

export const contactSaveSuccess = createAction(
    '[Contact] Save Succeeded',
    props<{ contact: Contact }>()
);

export const contactSaveFailure = createAction(
    '[Contact] Save Failed'
);

export const contactDeleteRequest = createAction(
    '[Contact Editor] Delete Selection'
);

export const contactDeleteSuccess = createAction(
    '[Contact Editor] Delete Succeeded'
);

export const contactDeleteFailure = createAction(
    '[Contact Editor] Delete Failure'
);
